var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigDrama(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 27.5H25.525M35.5 15H35.525M45.5 15H45.525M16.75 32.7499H16.775M44.0002 24.7501C42.0002 26.7501 39.0002 26.7501 37.0002 24.7501M25.7505 17.7499C23.0005 17.9999 19.7505 19.2499 15.5005 21.4999C6.75048 26.4999 3.75048 31.2499 6.25048 35.4999C17.5005 54.9999 30.0005 56.4999 34.2505 53.9999C36.5005 52.7499 39.0005 48.7499 39.0005 42.2499M23.2502 41.2501C24.0002 38.5001 26.7502 37.0001 29.2502 37.7501M55.5 12.5C55.5 35 45.5 42.5 40.5 42.5C35.5 42.5 25.5 35 25.5 12.5C25.5 7.5 30.5 5 40.5 5C50.5 5 55.5 7.5 55.5 12.5Z",
    stroke: "#4B286D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigDrama);
export default __webpack_public_path__ + "static/media/big-drama.761b35b6149de2550cd0d5acb2e61b21.svg";
export { ForwardRef as ReactComponent };